export const BASE_URL = 'validate';
export const EXPIRED_PATH = 'expired';
